import axios from "axios";

// Recurring Invoice. None of these endpoints exist on the server yet — the full
// contract (request and response shapes, scheduler rules) is
// docs/BACKEND-COMPLETE.md (Part 5.6).
const base_path = window.APP_CONFIG?.BASE_URL;
const R = `${base_path}/api/RecurringInvoice`;

/* ---------------------------------------------------------------- profiles */

export const getRecurringProfiles = async (globalBranchID) => {
  const response = await axios.get(`${R}/GetProfiles?globalBranchID=${globalBranchID}`);
  return response.data;
};

export const getRecurringProfileByGuid = async (guid) => {
  const response = await axios.get(`${R}/GetProfileByGuid?guid=${guid}`);
  return response.data;
};

export const getNextProfileNo = async (globalBranchID) => {
  const response = await axios.get(`${R}/GetNextProfileNo?globalBranchID=${globalBranchID}`);
  return response.data;
};

// add when guid is empty, update otherwise (G-5)
export const saveRecurringProfile = async (data) => {
  const response = await axios.post(`${R}/SaveProfile`, data);
  return response;
};

export const deleteRecurringProfile = async (data) => {
  const response = await axios.post(`${R}/DeleteProfile`, data);
  return response;
};

// { guid, status: "Active" | "Paused" | "Completed" | "Cancelled", updatedUser }
export const setRecurringProfileStatus = async (data) => {
  const response = await axios.post(`${R}/SetProfileStatus`, data);
  return response;
};

// raises this cycle's invoice now and moves the next date on; returns the invoice
export const generateRecurringInvoiceNow = async (data) => {
  const response = await axios.post(`${R}/GenerateNow`, data);
  return response.data;
};

// runs the scheduler for the branch now; returns { raised, failed }
export const runRecurringScheduler = async (data) => {
  const response = await axios.post(`${R}/RunScheduler`, data);
  return response.data;
};

/* ---------------------------------------------------------------- invoices */

export const getRecurringInvoices = async (globalBranchID, fromDate, toDate) => {
  const q = new URLSearchParams({ globalBranchID: globalBranchID || "" });
  if (fromDate) q.set("fromDate", fromDate);
  if (toDate) q.set("toDate", toDate);
  const response = await axios.get(`${R}/GetInvoices?${q.toString()}`);
  return response.data;
};

// edit a pending invoice (dates, lines, notes) before it is paid
export const updateRecurringInvoice = async (data) => {
  const response = await axios.post(`${R}/UpdateInvoice`, data);
  return response;
};

// posts the tax invoice (InvSale) and the receipt in one go, marks the cycle paid
export const receiveRecurringPayment = async (data) => {
  const response = await axios.post(`${R}/ReceivePayment`, data);
  return response.data;
};

export const cancelRecurringInvoice = async (data) => {
  const response = await axios.post(`${R}/CancelInvoice`, data);
  return response;
};

export const emailRecurringInvoice = async (data) => {
  const response = await axios.post(`${R}/EmailInvoice`, data);
  return response;
};

/* ---------------------------------------------------------------- settings */

export const getRecurringSettings = async (globalBranchID) => {
  const response = await axios.get(`${R}/GetSettings?globalBranchID=${globalBranchID}`);
  return response.data;
};

export const saveRecurringSettings = async (data) => {
  const response = await axios.post(`${R}/SaveSettings`, data);
  return response;
};
